import React from 'react';
import styled, { css } from 'styled-components';
import Video from '@components/VideoModule';
import { PageSlice, SliceVideoDetails } from '@contracts';
import LazyLoadVideo from './LazyLoadVideo';
import useDesktop from './useDesktop';

interface Props {
  slice: PageSlice;
}

const VideoSlice: React.FC<Props> = ({ slice }) => {
  const { video, mobile_video, cover, height, width, background_color, mobile_width, mobile_height } = slice.primary as SliceVideoDetails;
  const backgroundColor = background_color || 'transparent';
  const desktopWidth = width.text !== '' ? Number(width.text) : undefined;
  const desktopHeight = height.text !== '' ? Number(height.text) : undefined;
  const mobileVideoWidth = mobile_width?.text ? Number(mobile_width.text) : 0;
  const mobileVideoHeight = mobile_height?.text ? Number(mobile_height.text) : 0;
  const videoSourceIsMobile = !useDesktop(mobileVideoWidth);
  const videoSource = video.url;
  const mobileVideoSource = mobile_video?.url;
  const videoWidth = mobileVideoWidth && videoSourceIsMobile ? mobileVideoWidth : desktopWidth;
  const videoHeight = mobileVideoHeight && videoSourceIsMobile ? mobileVideoHeight : desktopHeight;

  return (
    <Container $backgroundColor={backgroundColor} $cover={cover}>
      {videoSourceIsMobile ? (
        <LazyLoadVideo>
          <Video mp4={mobileVideoSource} cover={cover} width={mobileVideoWidth} height={mobileVideoHeight} />
        </LazyLoadVideo>
      ) : (
        <MobileWrapper>
          <LazyLoadVideo>
            <Video mp4={videoSource} cover={cover} width={videoWidth} height={videoHeight} />
          </LazyLoadVideo>
        </MobileWrapper>
      )}
    </Container>
  );
};

export default VideoSlice;

interface IContainer {
  $backgroundColor: string;
  $cover: boolean;
}

const Container = styled.div<IContainer>`
  background: ${(props) => props.$backgroundColor || 'transparent'};
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 100%;

  ${(props) =>
    !props.$cover
      ? css`
          > div {
            width: 100%;
            max-width: 1920px;
          }
        `
      : ''}
`;

const MobileWrapper = styled.div`
  width: 100%;
`;
